export default __webpack_public_path__ + "static/media/330_business01-es-web.d3ad14bd.png";